import { render, staticRenderFns } from "./EmptyMessage.vue?vue&type=template&id=d1a908ce&scoped=true&"
import script from "./EmptyMessage.vue?vue&type=script&lang=js&"
export * from "./EmptyMessage.vue?vue&type=script&lang=js&"
import style0 from "./EmptyMessage.vue?vue&type=style&index=0&id=d1a908ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a908ce",
  null
  
)

export default component.exports